import { takeEvery, call, put } from 'redux-saga/effects';
import { getUpsellFaresRequest, getUpsellFaresResponse } from '../../slices/flight';
import axios from '../axiosConfig';

const fareCount = (itinerary) => {
  const flight =
    itinerary &&
    itinerary.flightSegments &&
    itinerary.flightSegments[0] &&
    itinerary.flightSegments[0].flights &&
    itinerary.flightSegments[0].flights[0];
  return (flight && flight.allFares && flight.allFares.length) || 0;
};

// "More Classes" full ladder (As of 2026-07-19 applies only for Travelport):
// the backend enriches the posted itinerary with up to 99 branded fares via Flight Specific Search.
// It never fails the call — on any provider problem returns the original itinerary,
// so a same-size response means "ladder already complete".
function* getUpsellFaresWorker({ payload: { flightKey, flightItinerary } }) {
  try {
    const config = {
      method: 'post',
      url: '/flights/upsellFares/itinerary',
      data: JSON.stringify(flightItinerary),
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const response = yield call(axios, config);

    // 204 = the backend could not OBTAIN the full ladder (provider error / expired search cache) —
    // surface a retryable error instead of marking the ladder complete.
    if (response.status === 204) {
      yield put(getUpsellFaresResponse({ flightKey, error: 'Unable to load additional fares' }));
      return;
    }

    const { data } = response;

    const grew = fareCount(data) > fareCount(flightItinerary);

    yield put(
      getUpsellFaresResponse({
        flightKey,
        error: null,
        itinerary: grew ? data : null,
      }),
    );
  } catch {
    yield put(
      getUpsellFaresResponse({
        flightKey,
        error: 'Unable to load additional fares',
      }),
    );
  }
}

function* getUpsellFaresWatcher() {
  // takeEvery, not takeLatest: each result card fetches independently.
  yield takeEvery(getUpsellFaresRequest.toString(), getUpsellFaresWorker);
}

export default getUpsellFaresWatcher;
